export const GRID_REDUCER_STATE_ID = 'grid';

export const DEFAULT_GRID_PAGE_SIZE = 10;

export const GRID_STATE_LOADING = 'loading';
export const GRID_STATE_STABILIZED = 'stabilized';

export const GRID_ACTION_FETCH_DATA = 'FETCH_DATA';
export const GRID_ACTION_FIRST_RENDER = 'FIRST_RENDER';
export const GRID_ACTION_SORT = 'SORT';
export const GRID_ACTION_FILTER = 'FILTER';
export const GRID_ACTION_PAGE = 'PAGE';
export const GRID_ACTION_SCROLL = 'SCROLL';
export const GRID_ACTION_FILTER_BUTTONS = 'FILTER_BUTTONS';

export const GRID_SORT_MODEL_SORT_COLUMN = 'colId';
export const GRID_SORT_MODEL_SORT_DIRECTION = 'sort';

export const GRID_HEADER_HEIGHT = 40;
